export const objectToFormData = (object: { [x: string]: any }, form?: FormData, namespace?: string): FormData => {
    let formData: FormData = form || new FormData();
    let formKey: string;

    for (let property in object) {
        if (object.hasOwnProperty(property)) {
            if (namespace) {
                formKey = namespace + "[" + property + "]";
            } else {
                formKey = property;
            }

            if (typeof object[property] === "object" && !(object[property] instanceof File)) {
                objectToFormData(object[property], formData, formKey);
            } else if (object[property] instanceof File) {
                formData.append(formKey, object[property], object[property]?.name);
            } else if (typeof object[property] === "object" && Array.isArray(object[property])) {

            } else {
                formData.append(formKey, object[property]);
            }
        }
    }

    return formData;
};
